import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "services/api.service";
import { Location } from "types/location";

// Shared so `locations` keeps the same reference while the query is loading.
// Callers memoize on it (ReturnAddressRadioGroup sets state from a useMemo),
// and a fresh [] on every render loops forever ("Too many re-renders").
const NO_LOCATIONS: Location[] = [];

export default function useLocations(countryCode?: string, enabled = true) {
  const path = countryCode ? `/locations?country_code=${countryCode}` : "/locations";
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["locations", countryCode ?? null],
    queryFn: () => api.get<{ locations: Location[] }>(path).then(({ data: body }) => body.locations),
    enabled,
  });

  const refetchLocations = useCallback(() => refetch().then(() => undefined), [refetch]);

  return {
    locations: data ?? NO_LOCATIONS,
    isLoading,
    isError,
    refetch: refetchLocations,
  };
}
